import { render, staticRenderFns } from "./serveOne.vue?vue&type=template&id=1854061e&scoped=true"
import script from "./serveOne.vue?vue&type=script&lang=js"
export * from "./serveOne.vue?vue&type=script&lang=js"
import style0 from "./serveOne.vue?vue&type=style&index=0&id=1854061e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854061e",
  null
  
)

export default component.exports